import React from "react";

import PrivateRouter from "./PrivateRouter";
import PublicRouter from "./PublicRouter";
import { useSession } from "./Session";

const MainRouter = () => {
	const { hasSession, isReady } = useSession();

	if (!isReady) {
		return null;
	}

	const Router = hasSession ? PrivateRouter : PublicRouter;

	return <Router />;
};

export default MainRouter;
